import { FilterBaseComponent } from "./filter-base-component.js";
import type { ColumnData, AmbitoFilter, CategoryFilter } from "../../types/ListManagerTypes.js";
import { FILTER_OPERATORS, FilterOperator } from "../../constants/FilterConstants.js";
import { BonusCategories } from "../bonus-categories/bonus-categories.js";

export class FilterCategoriesComponent extends FilterBaseComponent {
    static webComponentName: string = "form-categories-filter";
    protected _templateId: string = 'filter-categories-template'; // Template ID for rendering

    // Supported operators for  filters (from centralized constants)
    private static readonly OPERATORS = FILTER_OPERATORS.categories;
    protected categoriesControl!: BonusCategories;
    protected _operator: FilterOperator = '='; // Default operator

    get operator(): FilterOperator {
        return this._operator;
    }

    set operator(value: FilterOperator) {
        return; // No operator change allowed 
    }
    get filterValue(): any {
        if (!this.categoriesControl) {
            return [];
        }
        return this.categoriesControl ? this.categoriesControl.value : [];
    }
    /**
     * Generate CategoryFilter object from current UI state
     */
    generateFilter(): CategoryFilter {
        return {
            type: 'categories',
            columnName: this.fieldName,
            searchTerm: this.filterValue,
            operator: "="
        };
    }

    /**
     * Get available operators for  filter
     */
    getAvailableOperators(): string[] {
        return ['='];
    }

    /**
     * Validate filter value based on operator
     */
    validateFilterValue(): boolean {
        if (!this.categoriesControl) {
            return false;
        }

        const selectedValues = this.categoriesControl.value;
        return Array.isArray(selectedValues) && selectedValues.length > 0;
    }

    protected onPrepareData(data: Record<string, any>): Record<string, any> {
        // Override to add any additional data needed for template
        return {
            ...data,
            filterId: this.filterId,
        }
    }

    initialize(colData: ColumnData): void {
        super.initialize(colData);
    }

    protected afterRender() {
        this.categoriesControl = this.querySelector('bonus-categories') as BonusCategories;
    }
    rendered: boolean = false;
    protected render(): void {
        if (this.rendered) {
            return;
        }
        super.render();
        this.rendered = true;
    }
    protected setupEventListeners(): void {
        if (this.categoriesControl) {
            // Ascoltare cambiamenti di valore dal componente figlio
            this.categoriesControl.addEventListener('categories-value-changed', (e: Event) => {
                // this.dispatchFilterEvent("change"); // se esiste
                this.dispatchValueChange(); // nuovo standard
            });
        }
    }
}   